import React from "react";
import { useSelector } from "react-redux";
import { Formik, Form, Field } from "formik";
import classNames from "classnames";
import { makeStyles } from "@material-ui/styles";
import { Button } from "@mantine/core";
import MuiTextInput from "../../Common/MuiTextInput";
import validate from "./validate";

const useStyles = makeStyles((theme) => ({
  formRow: {
    display: "grid",
    gridTemplateColumns: "1fr auto",
    gridGap: "16px",
    margin: "16px 0",
    "@media(max-width: 576px)": {
      gridTemplateColumns: "1fr",
    },
  },
  buttonContainer: {
    marginTop: "16px",
    borderTop: `1px solid ${theme.app.borderColor}`,
    padding: "8px 0",
    display: "grid",
    gridTemplateColumns: "1fr auto",
    alignItems: "center",
  },
  button: {
    color: theme.app.labelColor,
  },
}));

const RequestForm = (props) => {
  const { initialValues, handleSubmit } = props;
  const language = useSelector((state) => state.language);
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Formik
        initialValues={initialValues}
        onSubmit={(values, actions) => handleSubmit(values, actions)}
        validate={(values) => validate(values, language)}
        render={(props) => (
          <Form>
            <div className={classes.formRow}>
              <Field
                component={MuiTextInput}
                name="email"
                label={`${
                  language.MemberForm && language.MemberForm.Email_Label
                }`}
                placeholder={`${
                  language.MemberForm && language.MemberForm.Email_Placeholder
                }`}
                type="text"
              />
            </div>
            <div className={classes.buttonContainer}>
              <div>
                <Button
                  className={classes.button}
                  onClick={() => window.history.back()}
                  variant="subtle"
                  color="dark"
                >
                  {language.Back}
                </Button>
              </div>
              <div>
                <Button
                  disabled={!props.isValid || props.isSubmitting}
                  type="submit"
                  color="primary"
                  className={classNames(
                    classes.submitButton,
                    "password__submit-button primaryButton"
                  )}
                >
                  {language.Send ? language.Send : "skicka"}
                </Button>
              </div>
            </div>
          </Form>
        )}
      />
    </div>
  );
};

export default RequestForm;
